exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editable-text {\n  display: inline-block;\n  min-width: 200px;\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  cursor: text;\n}\n", ""]);

// exports
